import { DocumentState } from '../documents';

export type InvoiceState =
  | DocumentState.CONTRACT_DRAFT
  | DocumentState.DRAFT
  | DocumentState.REVIEW_MISSING_DATA
  | DocumentState.REVIEW_READY_TO_SEND
  | DocumentState.COLLECTING_INFO
  | DocumentState.PAYMENT_FAILED_COLLECTING_INFO
  | DocumentState.FINALIZED
  | DocumentState.SENT
  | DocumentState.SENT_FAILED
  | DocumentState.LATE
  | DocumentState.PAID
  | DocumentState.PAYMENT_FAILED
  | DocumentState.CANCELED;

/** Runtime list of every `InvoiceState` value — the union above, materialized for validation and Swagger enums. */
export const InvoiceStates: InvoiceState[] = [
  DocumentState.CONTRACT_DRAFT,
  DocumentState.DRAFT,
  DocumentState.REVIEW_MISSING_DATA,
  DocumentState.REVIEW_READY_TO_SEND,
  DocumentState.COLLECTING_INFO,
  DocumentState.PAYMENT_FAILED_COLLECTING_INFO,
  DocumentState.FINALIZED,
  DocumentState.SENT,
  DocumentState.SENT_FAILED,
  DocumentState.LATE,
  DocumentState.PAID,
  DocumentState.PAYMENT_FAILED,
  DocumentState.CANCELED,
];

export const InvoiceNonSentStates = [
  DocumentState.DRAFT,
  DocumentState.REVIEW_MISSING_DATA,
  DocumentState.REVIEW_READY_TO_SEND,
  DocumentState.COLLECTING_INFO,
  DocumentState.PAYMENT_FAILED_COLLECTING_INFO,
];

export const InvoiceCreditAllocationStates = [
  DocumentState.CONTRACT_DRAFT,
  DocumentState.DRAFT,
  DocumentState.REVIEW_MISSING_DATA,
  DocumentState.REVIEW_READY_TO_SEND,
] as const;

export const InvoiceNumberAllocationStates = [
  DocumentState.SENT,
  DocumentState.SENT_FAILED,
  DocumentState.LATE,
  DocumentState.PAID,
  DocumentState.PAYMENT_FAILED,
] as const;

// when to lock a usage report invoice
export const InvoiceUsageLockingStates = [
  DocumentState.FINALIZED,
  DocumentState.SENT,
  DocumentState.SENT_FAILED,
  DocumentState.LATE,
  DocumentState.PAID,
  DocumentState.PAYMENT_FAILED,
] as const;

export const InvoiceLockingStates = [DocumentState.COLLECTING_INFO, ...InvoiceUsageLockingStates] as const;

export const InvoicePayableStates = [
  DocumentState.SENT,
  DocumentState.SENT_FAILED,
  DocumentState.LATE,
  DocumentState.PAYMENT_FAILED,
] as const;

export const InvoiceExportStates = [
  DocumentState.REVIEW_READY_TO_SEND,
  DocumentState.COLLECTING_INFO,
  DocumentState.SENT,
  DocumentState.LATE,
  DocumentState.PAID,
] as const;
